//web wap端第三方賬號綁定
export var mixin = {
  data() {
    return {
      webWapisLogin: true,
      oauthCallback: null,
      accountList: {
        Facebook: null,
        Google: null,
      },
    };
  },
  mounted() {},
  methods: {
    initWebWapOauth(opt) {
      if (opt.bindOauth) {
        this.webWapisLogin = false;
        this.oauthCallback = opt.callback;
      }
      if (opt.Facebook) {
        this.$loadScript.loadScript(
          "https://connect.facebook.net/zh_TW/sdk.js#xfbml=0&version=v5.0",
          () => {
            FB.init({
              appId: opt.Facebook.appId,
              cookie: true,
              xfbml: false,
              version: opt.Facebook.version || "v5.0",
            });
            //绑定事件
            let btnEl = document.getElementById(opt.Facebook.btnId);
            if (btnEl) {
              btnEl.addEventListener("click", () => {
                FB.login(this.onFacebookLogin, {
                  scope: "public_profile,email",
                });
              });
            }
          }
        );
      }
      if (opt.Google) {
        this.$loadScript.loadScript(
          "https://apis.google.com/js/api:client.js",
          () => {
            let that = this;
            let auth2 = null;
            gapi.load("auth2", function() {
              auth2 = gapi.auth2.init({
                client_id: opt.Google.client_id,
                cookiepolicy: "single_host_origin",
                scope: "profile email",
              });
              let googleBtnEl = document.getElementById(opt.Google.btnId);
              if (googleBtnEl) {
                auth2.attachClickHandler(
                  googleBtnEl,
                  {},
                  that.onGoogleSignIn,
                  function(error) {}
                );
              }
            });
          }
        );
      }
    },
    onGoogleSignIn(user) {
      var id_token = user.getAuthResponse().id_token;
      this.doOauthLogin({
        data: JSON.stringify({
          type: "google",
          client: "Web",
          idToken: id_token,
        }),
      });
    },

    onFacebookLogin(response) {
      this.doOauthLogin({
        data: JSON.stringify({
          type: "facebook",
          client: "Web",
          accessToken: response.authResponse.accessToken,
        }),
      });
    },

    doOauthLogin(postD) {
      if (this.webWapisLogin) {
        oauthSDK
          .loginOAUTH(postD)
          .then((res) => {
            // this.$message({
            //   message: "登錄成功",
            //   type: "success",
            // });
            // this.defalutToast("登錄成功", "success");
            this.defalutToast(this.language('login.tipsText15'), "success");
            oauthSDK.redirectURL('login');
          })
          .catch((err) => {
            if (err.code == 40103) {
              //用户未注册
              try {
                let postData = JSON.parse(postD.data);
                // this.defalutToast(
                //   `你的${postData.type}賬號未綁定賬號，請先註冊/登入`
                // );
            this.defalutToast(this.language('login.tipsText10'));

              } catch (error) {
                // this.defalutToast(`你的賬號未綁定賬號，請先註冊/登入`);
            this.defalutToast(this.language('login.tipsText10'));

              }
            } else if (err.code == 401) {
              this.user401(err)
              this.defalutToast(err.message);
            } else {
              // this.defalutToast("登入失败！");
            this.defalutToast(this.language('login.tipsText16'));

            }
          });
      } else {
        this.oauthCallback(postD);
      }
    },

    bindWebWapOauth(postD) {
      oauthSDK
        .bindOauth(postD)
        .then((res) => {
          // this.defalutToast("綁定成功", "success");
          this.defalutToast(this.language('login.tipsText11'), "success");
          this.getOauthList();
        })
        .catch((err) => {
          if (err.code == 401 || err.code == 40104) {
            this.user401(err)
            this.defalutToast(err.message);
          } else {
            this.defalutToast(this.language('login.tipsText12'));
          }
        });
    },
    unbindOauth(type) {
      this.$confirm(this.language('userData.tipsText60'), this.language('ui.tipsTitle'), {
        confirmButtonText:  this.language('userData.tipsText81'),
        cancelButtonText:  this.language('form.cancelBtn'),
        type: "warning",
      })
        .then(() => {
          let postD = {
            type: type,
          };
          oauthSDK
            .unbindOauth(postD)
            .then((res) => {
              this.defalutToast( this.language('userData.tipsText61'), "success");
              this.getOauthList();
            })
            .catch((err) => {
              this.user401(err)
              this.defalutToast(err.message);
            });
        })
        .catch(() => {});
    },
    getOauthList() {
      if(!this.$urlData.bsKey || this.$urlData.bsKey==""){
        return false
      }
      oauthSDK
        .getOauthList()
        .then((res) => {
          this.accountList = {
            Facebook: null,
            Google: null,
          };
          res.forEach((oa) => {
            var code = oa.thirdType;
            if (oa.thirdType == "facebook") {
              code = "Facebook";
            }
            if (oa.thirdType == "google") {
              code = "Google";
            }
            this.accountList[code] = oa;
          });
        })
        .catch((err) => {
          this.user401(err)
          this.defalutToast(err.message);
        });
    },
  },
};
